<style scoped lang="scss">
.strengths{
  display: flex;
  margin-top: 30px;
  li{
    flex:1;
    text-align: center;
    border-right: 1px solid #eee;
    padding:0 40px;
    &:last-child{
      border: 0;
    }
    h4{
      font-size: 18px;
      margin-bottom: 10px;
      color:#014492;
    }
  }
}
.cons{
  display: none;
}
.download{
  display: flex;
  flex-wrap: wrap;
  border-left: 1px solid #E4E6EA;
  li{
    width:50%;
    padding:20px 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #E4E6EA;
    border-right: 1px solid #E4E6EA;
    font-size: 16px;
    cursor: pointer;
    &:nth-of-type(1){
      border-top: 1px solid #E4E6EA;
    }
    &:nth-of-type(2){
      border-top: 1px solid #E4E6EA;
    }
    &:hover{
      color:#014492;
    }
  }
  .btn-primary{
    font-size: 14px;
    span{
      margin-right: 7px;
    }
  }
  .mr41{
    display: block;
  }
  .mr42{
    display: none;
  }
}
.table{
  tr{
    td:first-child{
      background: #F6FAFD;
    }
  }
}
.c-title small{
  margin-top: 10px;
}
.required{
  margin-top: 50px;
  background: none!important;
  margin-left: 0!important;
  font-size: 16px;
}
.desc{
  font-size: 16px;
}
.effect-lists{
  //display: block!important;
  justify-content: space-between;
  flex-wrap:wrap;
  overflow: auto;
}
//.effect-lists1{
//  //display: block!important;
//  justify-content: center;
//  flex-wrap:wrap;
//  overflow: auto;
//}
.compose-type1{
  padding-bottom: 50px;
  background: url("../../assets/img/产品及服务/基因调控/基因干扰/ys_bj.png") no-repeat;
  background-size: 100% 100%;
}
@media
screen and (max-width: 375px) and (min-width: 374px),
screen and (max-width: 414px) and (min-width: 413px),
screen and (max-width: 640px) and (min-width: 600px),
screen and (min-width: 300px) and (max-width:400px)
{
  .effect-lists{
    justify-content: flex-start!important;
  }
}
</style>
<style scoped>
@import url("../../assets/sanger.css");
@import url("../../assets/service.css");
</style>
<template>
  <div class="wrap wrap-tec">
    <router-view></router-view>
    <div class="banner con" v-if="!$route.meta.invisibles">
      <img src="@/assets/img/产品及服务/基因调控/基因干扰/banner.jpg" class="img-fluid">
      <div class="info"></div>
    </div>
    <!---移动端-->
    <div class="banner cons" v-if="!$route.meta.invisibles">
      <img src="@/assets/img/二级标题Banner/基因干扰.jpg" class="img-fluid">
      <div class="info"></div>
    </div>
    <section v-if="!$route.meta.invisibles">
      <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;margin-bottom:  20px;">
        <bread></bread>
      </div>
      <div class="container" style="margin-bottom: 30px;">
        <p class="desc" style="margin-bottom: 20px;">基因干扰（gene interference）是指采用特定方式阻止或抑制致病基因的表达，以达到治疗疾病的目的。基因干扰目前应用广泛的是通过RNA干扰（RNAi）技术来下调目的基因表达。</p>
        <p class="desc" style="margin-bottom: 20px;">RNA干扰（RNA interference，RNAi）是指在进化过程中高度保守的、由双链RNA（double-stranded RNA，dsRNA）诱发的，导致同源mRNA发生高度特异性降解的现象。是一种RNA转录后调控基因表达的机制。目前在细胞水平上的RNAi主要有三种方式：siRNA、shRNA质粒和shRNA病毒。在RNAi应用中，shRNA文库构建是RNAi文库构建中的中间环节，shRNA的设计尤为重要。另一种利用基因干扰机制调控基因表达元件是反义寡核苷酸（Antisense Oligonucleotides，ASOs）。</p>
        <p class="desc" style="margin-bottom: 20px;">反义寡核苷酸（Antisense Oligonucleotides，ASOs）是一段由12-25个核苷酸组成的单链DNA或RNA小片段序列，能够针对性的阻断目的基因的转录或者翻译过程，从而达到基因调控的目的。</p>
        <p class="desc">擎科生物可提供基因干扰系列服务，包含shRNA慢病毒质粒构建、ASO/反义寡核苷酸产品等。</p>
      </div>
      <div class="container">
        <div class="c-title">服务类型<small>Service type</small></div>
        <div class="container con">
          <ul class="effect-lists1 effect-lists">
            <li v-for="(item, index) in types1" :key="index" class="pointer" :class="{active1: currentService === index}" @mouseover="currentService = index" @mouseout="currentService = -1" @click="$router.push(item.ref)">
              <img :src="`/static/img/gr_${item.img}${currentService===index ? '' : ''}.png`" style="width: 80px;">
              <p style="margin-top: 10px;">{{item.name}}</p>
            </li>
          </ul>
        </div>
        <div class="cons" style="margin-top: 20px;">
        <ul class="effect-lists1 effect-lists">
          <li v-for="(item, index) in types1" :key="index" class="pointer"  @click="$router.push(item.ref)">
            <img :src="`/static/img/gr_${item.img}${currentService===index ? '' : ''}.png`" style="width: 50px;height: 55px;">
            <p style="margin-top: 10px;font-size: 12px">{{item.name}}</p>
          </li>
        </ul>
      </div>
      </div>

      <div class="container">
        <!-- <div class="c-title">服务类型与报价</div>
        <TheTypeInfoTable /> -->
        <!-- <div class="container con">
          <ul class="effect-lists1 effect-lists">
            <li v-for="(item, index) in types1" :key="index" class="pointer" :class="{active1: currentService === index}" @mouseover="currentService = index" @mouseout="currentService = -1" @click="$router.push(item.ref)">
              <img :src="`/static/img/gr_${item.img}${currentService===index ? '' : ''}.png`" style="width: 80px;">
              <p style="margin-top: 10px;">{{item.name}}</p>
            </li>
          </ul>
        </div> -->
        <!-- <div class="cons" style="margin-top: 20px;">
          <ul class="effect-lists1 effect-lists">
            <li v-for="(item, index) in types1" :key="index" class="pointer"  @click="$router.push(item.ref)">
              <img :src="`/static/img/gr_${item.img}${currentService===index ? '' : ''}.png`" style="width: 50px;height: 55px;">
              <p style="margin-top: 10px;font-size: 12px">{{item.name}}</p>
            </li>
          </ul>
        </div> -->
      </div>

      <div class="compose-type1" style="margin-top: 100px;">
        <div class="container">
          <div class="c-title">服务优势<small>Service advantage</small></div>
          <div class="neirong" style="display: flex">
            <div class="left ">
              <img src="@/assets/img/产品及服务/基因调控/基因干扰/ys.png" class="img-fluid">
            </div>
            <div class="right">
              <div class="required">
                <p class="mb20">1.一站式定制型服务——从基因合成、载体构建到病毒包装，完整的上下游科研服务，全面多样化的解决方案</p>
                <p class="mb20">2.按时交付——按照客户需求灵活安排调整项目，严格把控质量</p>
                <p class="mb20">3.一对一技术支持——专业的售前售后服务，解决科研困惑，实验无忧。</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="c-title">资源中心<small>Resource center</small></div>
      <div class="container mt30 mb30">
        <ul class="download">
          <li v-for="item in resourcesLists" :key="item.id">
            {{item.name}}
            <el-button type="primary" class="mr41" icon="el-icon-download" v-if="item.resourceFile.fileType === 'PICTURE'" @click="bindDownLoad(item.resourceFile.visitedUrl, item.name)">下载</el-button>
            <el-button type="primary" class="mr41" icon="el-icon-download" @click="downFile(item)" v-else>下载</el-button>

            <el-button type="primary" class="mr42" size="mini" icon="el-icon-download" v-if="item.resourceFile.fileType === 'PICTURE'" @click="bindDownLoad(item.resourceFile.visitedUrl, item.name)">下载</el-button>
            <el-button type="primary" class="mr42" size="mini" icon="el-icon-download" @click="downFile(item)" v-else>下载</el-button>
          </li>
        </ul>
      </div>
      <div class="container">
        <div class="c-title">相关服务<small>Related services</small></div>
        <div class="container con">
          <ul class="effect-lists">
            <li v-for="(item, index) in types" :key="index" class="pointer" :class="{active: currentType === index}" @mouseover="currentType = index" @mouseout="currentType = -1" @click="$router.push(item.ref)">
              <img :src="`/static/img/tk_${item.img}${currentType===index ? '' : ''}.png`">
              <p style="margin-top: 10px;">{{item.name}}</p>
            </li>
          </ul>
        </div>
        <div class="cons" style="margin-top: 20px;">
        <ul class="effect-lists">
          <li v-for="(item, index) in types" :key="index" class="pointer"  @click="$router.push(item.ref)">
            <img :src="`/static/img/tk_${item.img}${currentType===index ? '' : ''}.png`" style="width: 60px;">
            <p style="margin-top: 10px;font-size: 12px">{{item.name}}</p>
          </li>
        </ul>
      </div>
      </div>
      <div class="container">
        <qk-consult type="Virus"/>
      </div>
    </section>
  </div>
</template>
<script>
import { resourceColumns, resourceDownloads } from '@/services/api.index'
import bread from "@/components/bread"

import { TheTypeInfoTable } from './child-components'

export default {
  components:{
    bread,
    TheTypeInfoTable
  },
  data () {
    return {
      currentType: -1,
      currentService: -1,
      types: [
        {name: '基因编辑', img: '1', ref: '/products/Gene_editing'},
        {name: '蛋白表达', img: '3', ref: '/products/Protein_expression'},
        {name: '甲基化检测', img: '4', ref: '/products/Methylation_detection'},
        {name: '基因过表达', img: '5', ref: ''},
        {name: '基因panel定制及SNP分型', img: '6', ref: '/products/Gene_SNP'},
      ],
      types1: [
        // {name: 'RNA合成', img: '4', ref: '/tec/compose3'},
        {name: 'siRNA/miRNA合成', img: '6', ref: '/products/siRNA_miRNA_synthesis'},        
        {name: '慢病毒包装', img: '5', ref: '/Virus/Lentivirus_packaging'},
        // {name: 'shRNA文库构建', img: '2', ref: '/products/shRNA_library_construction'},
        {name: 'shRNA慢病毒质粒构建', img: '1', ref: '/products/shRNA_lentiviral'},        
        {name: 'ASO/反义寡核苷酸', img: '3', ref: '/products/ASO_antisense'},
      ],
      page: 0,
      total: 0,
      resourcesLists: [],
      categoryId: ''
    }
  },
  created () {
    this.getResourceColumns()
  },
  methods: {
    // 资源栏目
    getResourceColumns () {
      resourceColumns().then(res => {
        this.menuLists = res.data
        this.total = this.baseMethods.getTotal(res)
        this.getResourcesLists(res.data[0].id)
      })
    },
    // 根据栏目id获取资源列表
    getResourcesLists (id) {
      this.categoryId = id
      resourceDownloads(1, this.page, 20).then(res => {
        this.resourcesLists = res.data
        this.total = this.baseMethods.getTotal(res)
      })
    },
    // 下载
    bindDownLoad (imgsrc, name) {
      this.baseMethods.downloadImage(imgsrc, name)
    },
    downFile (item) {
      this.baseMethods.courseDownload(item.resourceFile.visitedUrl, item.name)
    },
    // 翻页
    changePage (value) {
      this.page = value - 1
      this.getResourcesLists(this.categoryId)
    },

  }
}
</script>



// WEBPACK FOOTER //
// src/views/products/Gene_interference.vue